export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_TRAIN_TYPE_INFO = 'SET_TRAIN_TYPE_INFO' // 点击当前训练类型 存值
export const SET_ROUTER_LIST = 'SET_ROUTER_LIST'
export const SET_CUR_TRAIN = 'SET_CUR_TRAIN'
export const SET_WID = 'SET_WID'
export const SET_TRAINER_INFO = 'SET_TRAINER_INFO'
export const SET_SHOW_TRAINER_WECHAT = 'SET_SHOW_TRAINER_WECHAT'
